<div class="exam-input-container">
   <app-alert *ngIf="hasError" [state]="'error'">{{errorMsg}}</app-alert>
   <h1 id="on-demand-exams-at-h" tabindex="-1" i18n>Create Exam Session</h1>

   <app-test-center-selection [testCenterId]="existingInformation.testCenterId !== 0 ? existingInformation.testCenterId.toString() : ''" (validate)="validateTestCenter()"></app-test-center-selection>
   <app-language-selection [languageCode]="existingInformation.language" (validate)="validateLanguage()" [languages]="languages"></app-language-selection>
   <app-candidate-count [candidateCount]="existingInformation.candidateCount" (validate)="validateCandidateCount()"></app-candidate-count>
</div>
